import React from 'react'
import OurFaculty from '../../components/Our-faculty-component/Our-faculty'
import ContactUs from '../../components/contact-us-component/Contact-us'

function Index () {
  return (
    <>
    <OurFaculty/>
    <ContactUs/>
   
    </>
  )
}

export default Index
